import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { EnvironmentService } from '@services';
import { UI_DESCRIPTION_MAX_LENGTH } from '@validators';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
var EnvironmentModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(EnvironmentModalComponent, _super);
    function EnvironmentModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this._environmentService = _this._injector.get(EnvironmentService);
        return _this;
    }
    EnvironmentModalComponent.prototype.ngOnInit = function () {
        this.form = this._injector.get(FormBuilder).group({
            'name': [
                this.context.data.name,
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(100),
                ]),
            ],
            'description': [
                this.context.data.description,
                Validators.maxLength(UI_DESCRIPTION_MAX_LENGTH),
            ],
        });
    };
    EnvironmentModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.valid ||
            this.loading$.value) {
            return;
        }
        Object.assign(this.context.data, this.form.value);
        this.loading$.next(true);
        if (this.context.isNewEntry) {
            this._environmentService.add(this.context.data)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function (environment) {
                _this._dialogRef.close({
                    type: 1 /* Add */,
                    data: environment,
                });
            });
        }
        else {
            this._environmentService.update(this.context.data.id, this.context.data)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () {
                _this._dialogRef.close({
                    type: 2 /* Update */,
                    data: _this.context.data,
                });
            });
        }
    };
    return EnvironmentModalComponent;
}(UiModalComponent));
export { EnvironmentModalComponent };
